import { pathOr } from 'ramda';

import { IApplicationState } from '../../types/redux';

export const getIsAgent = (state: IApplicationState): boolean => {
  return pathOr(false, ['user', 'isAgent'], state);
};
